<div class="col-5 p-l-3 p-r-3 p-b-4"
     [ngSwitch]="!!expandableTitle">
    <div class="flex flex-justify-between cursor-pointer col-1 p-t-4 "
         [zippyToggle]="zippyId">

        <!-- title -->
        <div class="flex-grow w-12">
            <label class="p1"
                   *ngSwitchCase="true">
                {{expandableTitle}}
            </label>
            <ng-container *ngSwitchCase="false">
                <ng-container *ngTemplateOutlet="expandableTitleTpl"></ng-container>
            </ng-container>
        </div>
        <!-- icon -->
        <div lineHeightBy="s1">
            <i [zippyName]="zippyId"
               class="icon-plus"
               zippyClass="icon-minus !icon-plus"></i>
        </div>
    </div>

    <!-- body -->
    <div class="hide-up-container">
        <div class="ng-hide ng-hide-animate hide-up"
             [zippy]="zippyId">
            <ng-container *ngSwitchCase="true">
                <ng-container *ngTemplateOutlet="expandableContentTpl"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="false">
                <ng-container *ngTemplateOutlet="expandableBodyTpl"></ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #expandableTitleTpl>
    <ng-content select="[expandableTitle]"></ng-content>
</ng-template>
<ng-template #expandableBodyTpl>
    <ng-content select="[expandableBody]"></ng-content>
</ng-template>
<ng-template #expandableContentTpl>
    <ng-content></ng-content>
</ng-template>